import { roles } from "../../constants/roles";
import { wordpressCategoryIds } from "../../pages/constants/wordpress";
import {
  aboutUsMenuItems,
  aboutUsMenuItemsCustomer,
  businessMenuItems,
  loggedInSupportItems,
  ourServicesMenuItems,
  providersMenuItems,
  sustainabilityItems,
} from "./constants";

export const buildMenuItemsForDisposal = (category, posts = []) => {
  const categoryCode = wordpressCategoryIds[category];
  const categoryPosts = posts.filter((post) => post.categories.includes(categoryCode));

  const menuItems = categoryPosts.map((post) => {
    let title = post.title?.rendered;
    const link = `/blog/${post.slug ?? ""}`;

    // trim down the title to 30 characters
    if (title.length > 30) {
      title = `${title.slice(0, 30)}...`;
    }

    return {
      label: title,
      link,
    };
  });

  // add a "View All" link at the end
  if (menuItems.length) {
    menuItems.push({
      label: "All Case Studies",
      link: `/case-studies`,
    });
  }

  return menuItems;
};

export const buildMobileHeaderMenu = ({ isLoggedIn, userType, category, posts = [], warriorBookings = [] }) => {
  const isProvider = userType === roles.provider.value;
  const disposalCaseStudies = buildMenuItemsForDisposal(category, posts);
  const isDisposalPage = [
    "alcohol-disposal",
    "beverage-disposal",
    "commercial-solar-panel-uninstallation-and-disposal",
    "compost-disposal",
    "fire-debris-removal",
    "hand-sanitizer-disposal",
    "hazardous-waste-disposal",
    "sanitizer-disposal",
    "solar-panel-disposal",
    "solar-panel-sell",
  ].includes(category);

  const caseStudiesMenuItems = [];

  if (!isProvider && isDisposalPage && disposalCaseStudies.length) {
    caseStudiesMenuItems.push(...disposalCaseStudies);
  }
  if (!isLoggedIn) {
    return [
      {
        label: "Our Services",
        menuItems: ourServicesMenuItems,
      },
      {
        label: "Case Studies",
        menuItems: caseStudiesMenuItems,
        ...(!caseStudiesMenuItems.length && { link: "/case-studies" }),
      },
      {
        label: "Business",
        menuItems: businessMenuItems,
        link: null,
      },
      {
        label: "Providers",
        menuItems: providersMenuItems,
        link: null,
      },
      {
        label: "Sustainability",
        menuItems: sustainabilityItems,
        link: null,
      },
      {
        label: "About Us",
        menuItems: aboutUsMenuItems,
        link: null,
      },
    ];
  }

  if (isProvider) {
    return [
      {
        label: "Provider Portal",
        menuItems: [],
        link: "/provider_portal",
      },
      ...(warriorBookings.length > 0
        ? [
            {
              label: "My Tasks",
              menuItems: [],
              link: "/tasks",
            },
          ]
        : []),
      {
        label: "Support",
        menuItems: loggedInSupportItems,
        link: null,
      },
    ];
  }

  return [
    {
      label: "Business",
      menuItems: businessMenuItems,
      link: null,
    },
    {
      label: "Sustainability",
      menuItems: sustainabilityItems,
      link: null,
    },
    {
      label: "About Us",
      menuItems: aboutUsMenuItemsCustomer,
      link: null,
    },
    {
      label: "Support",
      menuItems: loggedInSupportItems,
      link: null,
    },
  ];
};
